import CartComponent from '../../components/CartDialog.vue'
// import Vue from '../../main'
import { i18n } from "../i18n";
import { Row, Col } from "element-ui";

const Constructor = Vue.extend(CartComponent);

let cart;

const dialog = (product, status) => {
  if (!cart) {
    cart = new Constructor({
      i18n,
      el: document.createElement('div'),
      components: {
        Row,
        Col
      },
      methods: {
        beforeClose() {
          cart.dialogVisible = false
        },
        handlerClose() {
          cart.qty = ''
          cart.curSpec = {}
          cart.goodsDetail = {}
        }
      },
      propsData: {
        dialogVisible: false,
        addCartLoading: true,
        goodsDetail: {}
      }
    });
  }
  cart.goodsDetail = {...product}
  cart.dialogVisible = true,
  document.body.appendChild(cart.$el);
};

export default dialog;


// WEBPACK FOOTER //
// ./resources/js/lib/dialog/cart-dialog.js